import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { SubscriptionFragmentDoc } from './Subscription.generated';
import { CustomerDiscountFragmentDoc } from './CustomerDiscount.generated';
export type CustomerFragment = { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null };

export const CustomerFragmentDoc = gql`
    fragment CustomerFragment on MarketplaceCustomerType {
  id
  pk
  email
  firstName
  lastName
  sendNotifications
  subscribed
  subscriptionTypes {
    ...SubscriptionFragment
  }
  activationCode
  discount {
    ...CustomerDiscountFragment
  }
}
    ${SubscriptionFragmentDoc}
${CustomerDiscountFragmentDoc}`;